import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import CopyIcon from '@ad-scripts/presentation/components/common/icons/copy';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';
import useRouter from 'src/presentation/hooks/useRouter';

type CopyProps = {
  copyIcon?: any;
  dataAid?: string;
  id: string;
};

const Copy: FC<CopyProps & React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({
  id,
  dataAid,
  copyIcon: IconComponent = CopyIcon,
  ...rest
}) => {
  const { match } = useRouter();

  return (
    <Tooltip message="Duplicate" style={{ left: '5px' }} margin={13}>
      <StyledLink {...rest} data-aid={dataAid || `editLink-${id}`} to={`${match.url}/new#id=${id}`}>
        <IconComponent />
      </StyledLink>
    </Tooltip>
  );
};

const StyledLink = styled(Link)`
  visibility: hidden;
  color: ${p => p.theme.colors.gray500};
  cursor: pointer;
  height: 16px;
  & svg {
    height: 16px;
  }

  &:hover {
    color: ${p => p.theme.colors.green400};
  }
`;

export { Copy };
